<div class="content-wrapper">

    <div class="content-header row">
        <div class="content-header-left col-md-8 col-12 mb-2 breadcrumb-new">
            <h3 class="content-header-title mb-0 d-inline-block">
                Cuentas
            </h3>
            <div class="row breadcrumbs-top d-inline-block">
                <div class="breadcrumb-wrapper col-12">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a routerLink="/dashboard">
                                Dashboard
                            </a>
                        </li>
                        <li class="breadcrumb-item">
                            <a routerLink="/cuentas">
                                Cuentas
                            </a>
                        </li>
                        <li class="breadcrumb-item active">
                            Formulario de cuentas
                        </li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="content-header-right col-md-4 col-12">
            <div class="btn-group float-md-right">
                <button class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i class="icon-settings mr-1"></i>
                    Opciones
                </button>
                <div class="dropdown-menu arrow">
                    <a class="dropdown-item" routerLink="/planes/add">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i>
                        Nuevo Plan
                    </a>
                    <a class="dropdown-item" href="#">
                        <i class="fa fa-cart-plus mr-1"></i>
                        Cart
                    </a>
                    <a class="dropdown-item" href="#">
                        <i class="fa fa-life-ring mr-1"></i>
                        Support
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">
                        <i class="fa fa-cog mr-1"></i>
                        Settings
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="content-body">
        <!-- Basic form layout section start -->
        <section>
            <div class="row ">
                <div class="col-md-6 col-md-offset-3" style="margin: 0 auto;">
                    

                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Estos son los datos basicos de la cuenta</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a data-action="collapse"><i class="ft-minus"></i></a></li>
                                    <li><a data-action="reload"><i class="ft-rotate-cw"></i></a></li>
                                    <li><a data-action="expand"><i class="ft-maximize"></i></a></li>
                                    <li><a data-action="close"><i class="ft-x"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content collapse show">
                            <div class="card-body">
            
                                <div class="card-text">
                                    <p>
                                        Diligencie el siguiente formulario para actualizar la informacion de la cuenta
                                    </p>
                                </div>
            
                                <form class="form" #formCuenta="ngForm" (ngSubmit)="save()" >

                                    <div class="form-group">
                                        <label for="identificacion">
                                            Identificación
                                        </label>
                                        <div class="position-relative has-icon-left">
                                            <input type="text" class="form-control input-lg" #fieldIdentificacion="ngModel" [(ngModel)]="formData.identificacion" name="identificacion" id="identificacion" placeholder="Ingrese aqui su identificación" required>
                                            <div class="form-control-position">
                                                <i class="fa fa-id-card" aria-hidden="true"></i>
                                            </div>
                                            <div class="help-block font-small-3"></div>
                                        </div>
                                        <p class="block-tag text-right" *ngIf="fieldIdentificacion.invalid && (fieldIdentificacion.dirty || fieldIdentificacion.touched)">
                                            <small class="badge badge-default badge-danger" *ngIf="fieldIdentificacion.errors.required">
                                                Campo Requerido
                                            </small>
                                        </p>
                                    </div>
                                    
                                    <div class="form-group">
                                        <label for="nombres">
                                            Nombres
                                        </label>
                                        <div class="position-relative has-icon-left">
                                            <input type="text" class="form-control input-lg" #fieldNombres="ngModel" [(ngModel)]="formData.nombres" name="nombres" id="nombres" placeholder="Ingrese aqui su nombre" required>
                                            <div class="form-control-position">
                                                <i class="ft-user"></i>
                                            </div>
                                            <div class="help-block font-small-3"></div>
                                        </div>
                                        <p class="block-tag text-right" *ngIf="fieldNombres.invalid && (fieldNombres.dirty || fieldNombres.touched)">
                                            <small class="badge badge-default badge-danger" *ngIf="fieldNombres.errors.required">
                                                Campo Requerido
                                            </small>
                                        </p>
                                    </div>
            
                                    <div class="form-group">
                                        <label for="apellidos">
                                            Apellidos
                                        </label>
                                        <div class="form-group position-relative has-icon-left">
                                            <input type="text" class="form-control input-lg" #fieldApellidos="ngModel" [(ngModel)]="formData.apellidos" name="apellidos" id="apellidos" placeholder="Ingrese aqui su apellido" required>
                                            <div class="form-control-position">
                                                <i class="ft-user"></i>
                                            </div>
                                            <div class="help-block font-small-3"></div>
                                        </div>
                                        <p class="block-tag text-right" *ngIf="fieldApellidos.invalid && (fieldApellidos.dirty || fieldApellidos.touched)">
                                            <small class="badge badge-default badge-danger" *ngIf="fieldTelefono.errors.required">
                                                Campo Requerido
                                            </small>
                                        </p>
                                    </div>
            
                                    <div class="form-group">
                                        <label for="telefono">
                                            Teléfono
                                        </label>
                                        <div class="form-group position-relative has-icon-left">
                                            <input type="number" class="form-control input-lg" #fieldTelefono="ngModel"  [(ngModel)]="formData.telefono" name="telefono" id="telefono" placeholder="Ingrese aqui su telefono" required pattern="[0-9]{10}">
                                            <div class="form-control-position">
                                                <i class="ft-phone"></i>
                                            </div>
                                            <div class="help-block font-small-3"></div>
                                        </div>
                                        <p class="block-tag text-right" *ngIf="fieldTelefono.invalid && (fieldTelefono.dirty || fieldTelefono.touched)">
                                            <small class="badge badge-default badge-danger" *ngIf="fieldTelefono.errors.required">
                                                Campo Requerido
                                            </small>
                                            <small class="badge badge-default badge-danger" *ngIf="fieldTelefono.errors.pattern">
                                                Debe ser un número telefónico de 10 digitos, si es fijo agregarlo con indicativo
                                            </small>
                                        </p>
                                    </div>
            
                                    <div class="form-group">
                                        <label for="email">
                                            Correo
                                        </label>
                                        <div class=" position-relative has-icon-left">
                                            <input type="email" class="form-control input-lg" #fieldEmail="ngModel" [(ngModel)]="formData.email"  name="email" id="email" placeholder="Ingrese aqui su email" required email>
                                            <div class="form-control-position">
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </div>
                                            <div class="help-block font-small-3"></div>
                                        </div>
                                        <p class="block-tag text-right" *ngIf="fieldEmail.invalid && (fieldEmail.dirty || fieldEmail.touched)">
                                            <small class="badge badge-default badge-danger" *ngIf="fieldEmail.errors.required">
                                                Campo Requerido
                                            </small>
                                            <small class="badge badge-default badge-danger" *ngIf="fieldEmail.errors.email">
                                                Debe ser un correo válido
                                            </small>
                                        </p>
                                    </div>
            
                                    <button type="submit" class="btn btn-danger btn-block btn-lg" [disabled]="!formCuenta.valid">
                                        <i class="fa fa-pencil" aria-hidden="true"></i>
                                        Guardar Cambios
                                    </button>
                                </form>
            
                            </div>
                        </div>
                    </div>
            
                </div>
            </div>
        </section>
        <!-- // Basic form layout section end -->
    </div>

</div>